import React, { useState, useMemo, useRef, useEffect } from "react";

export default function CustomerSearchInput({
  customers = [],
  value, // selected customer object
  onChange, // (customer) => {}
  placeholder = "Search customer...",
  className = "",
  style = {},
  inputClass = "",
}) {
  const [search, setSearch] = useState("");
  const [showList, setShowList] = useState(false);
  const wrapperRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!wrapperRef.current?.contains(e.target)) {
        setShowList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter customers
  const filtered = useMemo(() => {
    if (!search) return customers;
    return customers.filter((c) =>
      `${c.name} ${c.phone}`.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, customers]);

  const handleSelect = (customer) => {
    onChange?.(customer);
    setSearch(`${customer.name} | ${customer.phone}`);
    setShowList(false);
  };

  // Pre-fill when value changes (edit mode etc.)
  useEffect(() => {
    if (value) {
      setSearch(`${value.name} | ${value.phone}`);
    } else {
      setSearch("");
    }
  }, [value]);

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", width: "100%", ...style }}
      className={className}
    >
      <input
        type="text"
        className={inputClass}
        placeholder={placeholder}
        value={search || ""}
        onFocus={() => setShowList(true)}
        onChange={(e) => {
          const val = e.target.value;
          setSearch(val);
          setShowList(true);

          // 🔥 IMPORTANT: clear selected customer when input is cleared
          if (!val.trim()) {
            onChange?.(null);
          }
        }}
      />

      {showList && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            maxHeight: 220,
            overflowY: "auto",
            background: "#fff",
            color: "#000",
            border: "1px solid #ddd",
            borderTop: "none",
            zIndex: 1000,
          }}
        >
          {filtered.length === 0 ? (
            <div style={{ padding: 10, fontSize: 12, color: "#888" }}>
              No customer found
            </div>
          ) : (
            filtered.map((c) => (
              <div
                key={c._id}
                style={{
                  padding: "8px 10px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={() => handleSelect(c)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#f5f5f5")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              >
                {/* Name */}
                <span style={{ fontSize: 13 }}>{c.name}</span>

                {/* Phone */}
                <span style={{ fontSize: 12, color: "#777" }}>{c.phone}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
